import { FeatureFlag } from '../../types/featureFlags.ts';
import { FeatureFlagsState } from '../reducers/featureFlags.reducer.ts';
import { RootState } from '../store.ts';

const getFeatureFlagsState = (state: RootState): FeatureFlagsState => state.featureFlags;

// Admin feature flags selectors
export const getFeatureFlags = (state: RootState): FeatureFlag[] => getFeatureFlagsState(state).featureFlags;
export const getIsLoadingFeatureFlags = (state: RootState): boolean => getFeatureFlagsState(state).isLoading;
export const getFeatureFlagsError = (state: RootState): string => getFeatureFlagsState(state).error;
export const getIsCreatingFeatureFlag = (state: RootState): boolean => getFeatureFlagsState(state).isCreating;
export const getIsUpdatingFeatureFlag = (state: RootState): boolean => getFeatureFlagsState(state).isUpdating;

// User feature flags selectors
// Kept for upcoming per-user feature flags (no current consumer).
// ts-unused-exports:disable-next-line
export const getUserFeatureFlags = (state: RootState): string[] => getFeatureFlagsState(state).userFeatureFlags;
export const getIsLoadingUserFeatureFlags = (state: RootState): boolean =>
  getFeatureFlagsState(state).isLoadingUserFeatureFlags;
